import {Component, ElementRef, HostBinding, Input, OnInit} from '@angular/core';
import {LocaleService} from '../../services/locale.service';
import {Locale} from '../../services/locale.service';
import {CommonModule} from '@angular/common';
// import {InsparkComponentsModule} from '@inspark/inspark-components';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {ClickOutsideDirective} from '../../click-outside.directive';
import {LocalStorageService} from '../../../../../projects/api/src/locale-storage/locale-storage.service';
import {InsparkUIModule} from '../../../inspark.module';

@Component({
  standalone: true,
  providers: [LocaleService],
  imports: [CommonModule, InsparkUIModule, TranslateModule, FormsModule, ClickOutsideDirective],
  selector: 'app-localization-picker',
  templateUrl: './localization-picker.component.html',
  styleUrls: ['./localization-picker.component.scss']
})
export class LocalizationPickerComponent implements OnInit {
  @Input() dropdownMode = false;
  @Input() localOnly = false;
  @HostBinding('class.is-dropdown_open') overlayIsOpen = false;
  public languages = this.localeService.languages;
  public currentLanguage: Locale;

  public selectedLanguage;
  constructor(private localeService: LocaleService, private localStorageApi: LocalStorageService, private element: ElementRef) {
  }

  public clickedOutsideOverlay(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.overlayIsOpen = false;
    }

  }

  public getCurrentLanguage() {
    const ilocale = this.localStorageApi.load(true, 'ilocale_');
    if (ilocale && this.localeService.locale$ && this.localeService.locale$.getValue().serverShort !== ilocale.replace(/'/g, '')) {
       this.localeService.setLocale(ilocale.replace(/'|"/g, ''));
    }
    return this.localeService.locale$.getValue();
  }

  public setCurrentLanguage(language) {
    if (this.localOnly) {
      this.localeService.setCurrentLanguageLocal(language);
    } else {
      this.localeService.setCurrentLanguage(language);
    }
    this.overlayIsOpen = false;
  }

  ngOnInit() {
    this.currentLanguage = this.getCurrentLanguage();
    this.selectedLanguage = this.currentLanguage;
  }

}
